module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon5.96c9b71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon5.png
// module id = lhIN
// module chunks = 1